export enum JSWRadioboticsFileType {
  DICOM_IMAGE = 'DICOM_IMAGE',
  DICOM_GSPS = 'DICOM_GSPS',
  JSON = 'JSON'
}
